<div class="flex-column">
    <div class="mts-4 mbs-3 ml-1">
        <div class="flex-row align-space-between-center">
            <div class="flex-row gap-0-5em">
                <!-- Selected -->
                <ng-container *tenantFeature="'provisionScheme.practicesTab'">
                <button mat-raised-button *ngIf="isProvision(); else activeNotSelected" class="provision-scheme-buttons"
                    matRipple id="lblProvisionsSelected" [color]="'primary'">
                    {{ 'modules.cases.provision-scheme.prestaciones' | exp:'':'Prestaciones' }}
                    <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
                <!-- Unselected -->
                <ng-template #activeNotSelected>
                    <button mat-stroked-button class="provision-scheme-buttons" matRipple
                        (click)="onSelectOption('PROVISION')" id="lblProvisionsNotSelected" [color]="'primary'">
                        {{ 'modules.cases.provision-scheme.prestaciones' | exp:'':'Prestaciones' }}
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>
                </ng-template>
                </ng-container>
                <!-- Selected -->
                <ng-container *tenantFeature="'provisionScheme.suppliesTab'">
                <button mat-raised-button
                    *ngIf="(!this.isCollapsedView && this.isSupply()) || (this.isCollapsedView && this.isSupply() && viewColumnsBillAndDebit)"
                    class="provision-scheme-buttons" matRipple id="lblSuppliesSelected" [color]="'primary'">
                    {{ 'modules.cases.provision-scheme.insumos' | exp:'':'Insumos' }}
                    <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
                <!-- Unselected -->
                <button mat-stroked-button class="provision-scheme-buttons" matRipple (click)="onSelectOption('SUPPLY')"
                    id="lblSuppliesNotSelected"
                    *ngIf="(!this.isCollapsedView && !this.isSupply()) || (this.isCollapsedView && !this.isSupply() && viewColumnsBillAndDebit)"
                    [color]="'primary'">
                    {{ 'modules.cases.provision-scheme.insumos' | exp:'':'Insumos' }}
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                </ng-container>
                <!-- Orders -->
                <ng-container *tenantFeature="'provisionScheme.ordersTab'">
                <button mat-raised-button *ngIf="!viewColumnsBillAndDebit && this.isCollapsedView && this.isOrder()"
                    class="provision-scheme-buttons" matRipple id="lblOrdersSelected" [color]="'primary'">
                    {{ 'modules.cases.provision-scheme.pedidos' | exp:'':'Pedidos' }}
                    <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
                <button mat-stroked-button class="provision-scheme-buttons" matRipple (click)="onSelectOption('ORDER')"
                    id="lblOrdersNotSelected"
                    *ngIf="!viewColumnsBillAndDebit && this.isCollapsedView && !this.isOrder()" [color]="'primary'">
                    {{ 'modules.cases.provision-scheme.pedidos' | exp:'':'Pedidos' }}
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                </ng-container>
                <!-- MODULES Selected -->
                <ng-container *tenantFeature="'provisionScheme.modulesTab'">
                <button mat-raised-button *ngIf="isModule()" class="provision-scheme-buttons" matRipple
                    id="lblModulesSelected" [color]="'primary'">
                    {{ 'modules.cases.provision-scheme.modules' | exp:'':'Módulos' }}
                    <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
                <!-- MODULES Unselected -->
                <button mat-stroked-button class="provision-scheme-buttons" matRipple (click)="onSelectOption('MODULE')"
                    id="lblModulesNotSelected" *ngIf="!this.isModule()" [color]="'primary'">
                    {{ 'modules.cases.provision-scheme.modules' | exp:'':'Módulos' }}
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                </ng-container>
            </div>
            <!-- Actions right -->
            <div class="flex-row" *ngIf="!this.case.requested">
                <button mat-icon-button [color]="'primary'" (click)="this.onClickCalendar()" [matTooltip]="'modules.cases.provision-scheme.tooltips.agenda' | exp:'':'Agenda'"
                    id="schedule_case">
                    <mat-icon
                        [svgIcon]="!this.visibleCalendarPanel ? 'calendar-enabled-primary' : 'calendar-disabled-primary'"></mat-icon>
                </button>
                <button mat-icon-button [color]="'primary'" (click)="this.onClickEvolutions()" [matTooltip]="'modules.cases.provision-scheme.tooltips.evoluciones' | exp:'':'Evoluciones'"
                    id="evolution_case">
                    <mat-icon
                        [svgIcon]="!this.visibleEvolution ? 'ListPlus-enabled-primary' : 'ListPlus-disabled-primary'"></mat-icon>
                </button>
                <button *tenantFeature="'provisionScheme.billingBtn'" mat-icon-button [color]="'primary'" (click)="this.onClickBilling()" [matTooltip]="('modules.cases.provision-scheme.facturar' | exp:'':'Facturar') | titlecase"
                    id="bill_case">
                    <mat-icon
                        [svgIcon]="!this.viewColumnsBillAndDebit ? 'billing-enabled-primary' : 'billing-disabled-primary'"></mat-icon>
                </button>
                <ng-container *tenantFeature="'provisionScheme.consolidationLink'">
                    <ng-container *ngIf="isAdmin">
                        <button id="btn_link_to_consolidation" mat-icon-button [matTooltip]="('modules.cases.provision-scheme.link-a-consolidacion' | exp:'':'Link a consolidación')"
                            (click)="linkToConsolidation()" [color]="'primary'" [disabled]="!isAdmin || !this.case?.active || this.case.rejected">
                            <mat-icon [svgIcon]="'Union-enabled-primary'" [ngClass]="{ 'line-icon-grey': (!this.case?.active || this.case.rejected) }"></mat-icon>
                        </button>
                    </ng-container>
                </ng-container>
                <button mat-icon-button [color]="'primary'"
                    [disabled]="!this.visibleCalendarPanel && !this.visibleEvolution && !this.viewColumnsBillAndDebit"
                    (click)="this.closePanel()" [matTooltip]="'modules.cases.provision-scheme.tooltips.ocultar' | exp:'':'Ocultar'" id="hide_case">
                    <mat-icon [svgIcon]="'exit-icon'" [color]="'primary'"
                        *ngIf="this.visibleCalendarPanel || this.visibleEvolution || this.viewColumnsBillAndDebit"></mat-icon>
                    <mat-icon [svgIcon]="'exit-disabled-icon'" [color]="'primary'"
                        *ngIf="!this.visibleCalendarPanel && !this.visibleEvolution && !this.viewColumnsBillAndDebit"></mat-icon>
                </button>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="flex-100">
        <as-split [unit]="'percent'" [restrictMove]="'false'">
            <as-split-area [size]="40">
                <app-theme-card themeScope="cases">
                    <ng-container *ngIf="isProvision()">
                        <app-provisions-detail [isExpanded]="!this.isCollapsedView" [case]="this.case" [supply]="false"
                            [isBilling]="this.viewColumnsBillAndDebit" [expandedElement]="this.expandedProvision"
                            [allProvisionsWithoutFilter]="this.allProvisionsWithoutFilter">
                        </app-provisions-detail>
                    </ng-container>
                    <ng-container *ngIf="isSupply()">
                        <div class="flex-column gap-20px">
                            <app-supply-list [isCollapsed]="this.isCollapsedView" [case]="this.case"
                                *ngIf="!this.isCollapsedView || (this.isCollapsedView && this.viewColumnsBillAndDebit)"
                                [isBilling]="this.viewColumnsBillAndDebit"
                                [provisionsFeeIdsToModifySupplies]="this.provisionsFeeIdsToModifySupplies"
                                (billSupplyAttentions)="billModifiedAttentions($event)"
                                [allProvisionsWithoutFilter]="this.allProvisionsWithoutFilter">
                            </app-supply-list>
                        </div>
                    </ng-container>
                    <app-supply-list *ngIf="isModule()"
                        #moduleSupplyList
                        style="display:none"
                        [isModuleContext]="true"
                        [case]="this.case"
                        [isBilling]="this.viewColumnsBillAndDebit"
                        [provisionsFeeIdsToModifySupplies]="this.provisionsFeeIdsToModifySupplies"
                        (billSupplyAttentions)="billModifiedAttentions($event)"
                        [allProvisionsWithoutFilter]="this.allProvisionsInCaseModules">
                    </app-supply-list>
                    <ng-container *ngIf="isOrder() || isSupply()">
                        <div class="mts-4 mxs-3 flex-column gap-20px">
                            <app-order-list [case]="this.case" [isCollapsed]="this.isCollapsedView"
                                *ngIf="!this.isCollapsedView || (this.isCollapsedView && !this.viewColumnsBillAndDebit)"
                                [allProvisionsWithoutFilter]="this.allProvisionsWithoutFilter">
                            </app-order-list>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isModule()">
                        <app-modules-scheme [caseId]="this.case.id" [caseModulesComposed]="this.caseModulesComposed"
                            [financierId]="this.case.financierId" [hideSuppliesSection]="this.visibleCalendarPanel || this.visibleEvolution"
                            [isCollapsed]="this.isCollapsedView" [hideOrdersSection]="this.visibleEvolution || this.viewColumnsBillAndDebit "
                            [singleSelectionMode]="this.isModuleSingleSelectionMode"
                            [resetChecks]="this.modulesResetDate"
                            (singleSelectedModuleChanged)="onSingleSelectedModuleChanged($event)"
                            (ordersRadioSelectedChanged)="onOrdersRadioSelectedChanged($event)"
                            (loadPriceRequested)="onLoadPriceRequestedFromModule($event)"
                            (caseModulesChanged)="this.refreshCaseModulesAfterAdd()"
                            (selectedCaseModuleIdsChanged)="onSelectedCaseModuleIdsChanged($event)">
                        </app-modules-scheme>
                    </ng-container>
                </app-theme-card>
            </as-split-area>
            <as-split-area [size]="60" *ngIf="this.visibleCalendarPanel || this.viewColumnsBillAndDebit">
                <app-theme-card themeScope="cases" cardClass="mts-5">
                    <app-schedule-case class="flex-100" [case]="this.case" [attentions]="this.attentionsCaseActive"
                        [allProvisionsWithoutFilter]="this.allProvisionsWithoutFilter"
                        [selectedCaseModuleFromParent]="this.singleSelectedCaseModule"
                        [ordersRadioSelected]="this.ordersRadioSelected"
                        [provisionAgreements]="!!this.provisionAgreementsFilters?.agreements ? this.provisionAgreementsFilters.agreements : []"
                        [viewColumnsBillAndDebit]="this.viewColumnsBillAndDebit" [selectedOption]="this.selectedOption"
                        [optionViewSelected]="calculateView()" [provisionsFilteredCount]="this.provisionsFilteredCount"
                        [provisionsSuppliesFilteredCount]="this.provisionsSuppliesFilteredCount"
                        [ordersFilteredCount]="this.ordersFilteredCount"
                        (agreementNewAttention)="this.receiveAgreementOfNewAttention($event)"
                        (refreshDataFiltered)="this.refreshViewFiltered()"
                        (openModifySuppliesProvisionFee)="this.openModifyProvisionFeeSupplies($event)"
                        (scheduleViewModeChanged)="this.scheduleViewMode = $event"
                        [billSuppliesExternally]="billModifiedSupplies" [caseModules]="caseModulesComposed"
                        [caseModuleProvisionFeesWithPractices]="caseModulesProvisionFeesWithPractices">
                    </app-schedule-case>
                </app-theme-card>
            </as-split-area>
            <as-split-area [size]="60" *ngIf="visibleEvolution">
                <app-theme-card themeScope="cases" cardClass="mts-5 mbs-3 mx-3">
                    <app-evolutions [case]="this.case" [data]="this.data"></app-evolutions>
                </app-theme-card>
            </as-split-area>
        </as-split>
    </div>
</div>
